import React from 'react';
import './Services.css';

const services = [
  {
    icon: '📚', title: 'NIOS Coaching',
    desc: 'Complete NIOS registration support and structured coaching for 10th & 12th board examinations with personalised study plans.',
    tag: 'Board Exams', color: '#1a56db', bg: 'rgba(26,86,219,0.08)',
  },
  {
    icon: '⭐', title: 'Special Education',
    desc: 'Tailored instruction for students with diverse learning needs, delivered by certified special educators with empathy and expertise.',
    tag: 'Inclusive', color: '#1e8a45', bg: 'rgba(30,138,69,0.08)',
  },
  {
    icon: '🧠', title: 'Learning Disability Management',
    desc: 'Expert assessment and intervention for dyslexia, dyscalculia, ADHD and other learning differences — building confidence from the ground up.',
    tag: 'Assessment & Support', color: '#e8681c', bg: 'rgba(232,104,28,0.08)',
  },
  {
    icon: '📖', title: 'Remedial Teaching',
    desc: 'Intensive, targeted academic support in specific subjects — building strong foundations and boosting student confidence.',
    tag: 'Academic', color: '#7c3aed', bg: 'rgba(124,58,237,0.08)',
  },
  {
    icon: '💬', title: 'Student Counselling',
    desc: 'Professional one-on-one guidance for academic stress, career choices, emotional well-being, and family dynamics.',
    tag: 'Psychology', color: '#0891b2', bg: 'rgba(8,145,178,0.08)',
  },
  {
    icon: '🎯', title: 'Behavior Therapy',
    desc: 'Cognitive Behaviour Therapy (CBT) sessions are designed to address behavioural challenges, manage anxiety, and build lasting positive habits',
    tag: 'CBT', color: '#d93025', bg: 'rgba(217,48,37,0.08)',
  },
];

export default function Services() {
  return (
    <section className="services reveal" id="services">
      <div className="services-inner">
        <div className="section-header">
          <span className="section-badge">What We Offer</span>
          <h2 className="section-title">Our Programmes &amp; Services</h2>
          <p className="section-sub">
            Comprehensive educational support covering academics, psychology, and personal development —
            designed for every unique learner.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s) => (
            <div
              className="service-card"
              key={s.title}
              style={{ '--accent': s.color }}
            >
              <div className="service-card-top">
                <div className="service-icon" style={{ background: s.bg }}>
                  {s.icon}
                </div>
                <span className="service-tag" style={{ background: s.bg, color: s.color }}>
                  {s.tag}
                </span>
              </div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
